import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppScope, Resource } from '@klickdata/core/resource';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { CourseManagerEventCreateComponent } from '../course-manager-core/course-manager-core-items/course-manager-core-add-event/course-manager-event-create/course-manager-event-create.component';
import { CourseManagerCoreMaterialManagerComponent } from '../course-manager-core/course-manager-core-items/course-manager-core-add-material/course-manager-core-material-manager/course-manager-core-material-manager.component';
import { CourseManagerCreateSurveyComponent } from '../course-manager-core/course-manager-core-items/course-manager-core-add-survey/course-manager-create-survey/course-manager-create-survey.component';
import { CourseManagerCreateTestComponent } from '../course-manager-core/course-manager-core-items/course-manager-core-add-test/course-manager-create-test/course-manager-create-test.component';
import { MessageService } from '@klickdata/core/message';
import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { CourseManagerCreateScormComponent } from '../course-manager-core/course-manager-core-items/course-manager-core-add-scorm/course-manager-create-scorm/course-manager-create-scorm.component';

@Component({
    selector: 'app-resource-edit-bottom-sheet',
    templateUrl: './resource-edit-bottom-sheet.component.html',
    styleUrls: ['./resource-edit-bottom-sheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceEditBottomSheetComponent extends OnDestroyHandler implements OnInit {
    AppScope = AppScope;
    @ViewChild('compRef') compRef: any;
    public editSource: boolean;
    public saving: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor(
        public bottomSheetRef: MatBottomSheetRef<ResourceEditBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: { resource: Resource; openedMaterialItemIndex?: number },
        protected message: MessageService
    ) {
        super();
    }

    ngOnInit(): void {
        this.bottomSheetRef
            .backdropClick()
            .pipe(takeUntil(this.destroy))
            .subscribe(() => this.done());
    }

    onError() {
        this.message.openMessage(MessageErrorComponent);
    }
    done() {
        this.saving.next(true);
        if (this.compRef instanceof CourseManagerEventCreateComponent) {
            this.compRef.submitEvent();
        } else if (this.compRef instanceof CourseManagerCoreMaterialManagerComponent) {
            this.compRef.submitMaterial();
        } else if (
            this.compRef instanceof CourseManagerCreateTestComponent ||
            this.compRef instanceof CourseManagerCreateSurveyComponent
        ) {
            this.compRef.onSubmit(true);
        } else if (this.compRef instanceof CourseManagerCreateScormComponent) {
            this.compRef.submitBtnClicked = true;
            this.compRef.onSubmit();
        }
    }

    onSubmit(res?: Resource) {
        this.saving.next(false);
        this.bottomSheetRef.dismiss({ resource: res, editSource: this.editSource });
    }
    onCancel() {
        this.bottomSheetRef.dismiss(false);
    }
}
